import { apiBaseFrom } from '../../shared/apiBase'
export interface ApiConfig {
  baseURL: string
  authURL: string
  orderURL: string
  employeeRostersURL: string
  employeesURL: string
  importTargetsURL: string
  importRunsURL: string
  orderLineReservationURL: string
  originCodeURL: string
  unitOfMeasureCodesURL: string
  truckingCompanyURL: string
  damageCodeURL: string
  attachmentTypeURL: string
  inspectionItemURL: string
  inspectionStopURL: string
  tirReceiptURL: string
  tirSettingsURL: string
  containerMovementURL: string
  containerDrayURL: string
  containerMovementReasonCodeURL: string
  yardPickCancelReasonCodeURL: string
  dataExchangeConnectionsURL: string
  dataExchangeConnectionChecksURL: string
  dataExchangeTransfersURL: string
  dataExchangeDocumentDefinitionsURL: string
  collectedFilesURL: string
  partnerNoticeFieldsURL: string
  dataExchangeDocumentDestinationsURL: string
  partnerCodeMapsURL: string
  unmatchedPartnerLocationCodesURL: string
  dataExchangeDocumentURL: string
  chassisURL: string
  gensetURL: string
  gangURL: string
  partnerURL: string
  partnerProductURL: string
  warehouseURL: string
  shipURL: string
  yardURL: string
  bayURL: string
  cellURL: string
  locationProximityURL: string
  yardPickURL: string
  yardPickSettingsURL: string
  containerURL: string
  inventorySupplyURL: string
  forecastURL: string
  forecastAlgorithmURL: string
  logURL: string
  jobScheduleURL: string
  jobSettingsURL: string
  tagURL: string
  orderSubtypesURL: string
  orderSubtypeImportSetupsURL: string
  palletImportSetupsURL: string
  orderImportSetupsURL: string
  shippingAgentsURL: string
  paymentsURL: string
  truckServicesURL: string
  truckServiceSettingsURL: string
  truckServicePricesURL: string
  cashDrawerURL: string
  cashDrawerClosesURL: string
  cashDrawerStartingCashURL: string
  cashDrawerDaysURL: string
  cardTerminalsURL: string
  textMessagesURL: string
  userURL: string
  partnerUsersURL: string
  healthURL: string
  monitoredServicesURL: string
  serviceEventsURL: string
  publicStatusURL: string
  palletsURL: string
  palletFilesURL: string
  palletMovesToConfirmURL: string
  unmappedContainersURL: string
  arrivedContainersURL: string
  crowdedCellsURL: string
  palletWrongContainersURL: string
  palletDestinationsURL: string
  palletIncidentURL: string
  palletIncidentReasonCodeURL: string
  palletIncidentStatusURL: string
  palletIncidentPredefinedPhotoURL: string
  warehouseRoomURL: string
  sensorURL: string
  roomClimateURL: string
  productStockURL: string
  palletStockURL: string
  containerStockURL: string
  scannerSettingsURL: string
  inventoryLocationURL: string
  securityURL: string
  serviceClientsURL: string
  permissionsURL: string
  siteSetupTemplateURL: string
  siteSetupWorkbooksURL: string
  gatesURL: string
  headers: {
    'Content-Type': string
  }
}

export function useApiConfig() {
  const config = useRuntimeConfig()
  const apiBase = apiBaseFrom(config.public.apiBase)

  return {
    baseURL: apiBase,
    authURL: `${apiBase}/auth`,
    orderURL: `${apiBase}/orders`,
    employeeRostersURL: `${apiBase}/employee-rosters`,
    employeesURL: `${apiBase}/employees`,
    importTargetsURL: `${apiBase}/import-targets`,
    importRunsURL: `${apiBase}/import-runs`,
    orderLineReservationURL: `${apiBase}/order-line-reservations`,
    originCodeURL: `${apiBase}/OriginCode`,
    unitOfMeasureCodesURL: `${apiBase}/unit-of-measure-codes`,
    truckingCompanyURL: `${apiBase}/trucking-companies`,
    damageCodeURL: `${apiBase}/trailer-interchange-damage-codes`,
    attachmentTypeURL: `${apiBase}/trailer-interchange-attachment-types`,
    inspectionItemURL: `${apiBase}/trailer-interchange-inspection-items`,
    inspectionStopURL: `${apiBase}/trailer-interchange-inspection-stops`,
    tirReceiptURL: `${apiBase}/trailer-interchange-receipts`,
    tirSettingsURL: `${apiBase}/trailer-interchange-settings`,
    containerMovementURL: `${apiBase}/container-movements`,
    containerDrayURL: `${apiBase}/container-drays`,
    containerMovementReasonCodeURL: `${apiBase}/container-movement-reason-codes`,
    yardPickCancelReasonCodeURL: `${apiBase}/yard-pick-cancel-reason-codes`,
    trailerLayoutsURL: `${apiBase}/trailer-layouts`,
    barcodingSettingsURL: `${apiBase}/barcoding-settings`,
    barcodeSettingsURL: `${apiBase}/barcoding-settings/barcodes`,
    // The forklift tablets' own Wi-Fi and motion lines, and the Tablets screen's reads (tasks 1703, 1705).
    tabletTelemetrySettingsURL: `${apiBase}/tablet-telemetry-settings`,
    telemetryTabletsURL: `${apiBase}/telemetry-tablets`,
    tabletFleetOverviewURL: `${apiBase}/tablet-fleet-overview`,
    tabletTimelinesURL: `${apiBase}/tablet-timelines`,
    driverSummariesURL: `${apiBase}/driver-summaries`,
    tabletTelemetryLinesURL: `${apiBase}/tablet-telemetry-lines`,
    // The tablet register (task 2540): the tablets and Missing After (tabletRegisterStore), and the
    // log-in sessions BOB records when it runs inside the Tablet Browser (tabletSessionStore).
    tabletsURL: `${apiBase}/tablets`,
    // The site's areas (task 2554, were the tablet kinds), shared by the tablets and the printers (areaStore).
    areasURL: `${apiBase}/areas`,
    tabletRegisterSettingsURL: `${apiBase}/tablet-register-settings`,
    // The Tablet Browser app's settings, All Tablets and one group per area (tabletRegisterStore).
    tabletSettingsURL: `${apiBase}/tablet-settings`,
    tabletSessionsURL: `${apiBase}/tablet-sessions`,
    trucksURL: `${apiBase}/trucks`,
    warehouseDoorsURL: `${apiBase}/warehouse-doors`,
    // The Door Board (task 2539): its read (doorBoardStore), the site's Door Views (doorViewStore) and
    // a view's TV, read with its display key and no login (doorViewDisplayStore).
    doorBoardURL: `${apiBase}/door-board`,
    doorViewsURL: `${apiBase}/door-views`,
    doorViewDisplaysURL: `${apiBase}/door-view-displays`,
    // The site's printers and the container label's ZPL (task 2449), both owned by printerStore.
    printersURL: `${apiBase}/printers`,
    containerLabelsURL: `${apiBase}/container-labels`,
    // BOB Print Relays (task 3490): the relays the Printers page approves, who may ask (Relays May
    // Join From), and the jobs every Print button sends.
    printRelaysURL: `${apiBase}/print-relays`,
    printRelaySettingsURL: `${apiBase}/print-relay-settings`,
    printJobsURL: `${apiBase}/print-jobs`,
    partnerLogosURL: `${apiBase}/partner-logos`,
    companyURL: `${apiBase}/company`,
    companyLogosURL: `${apiBase}/company-logos`,
    // The new-site workbook (task 2453): the template to fill, and a filled one checked and imported.
    siteSetupTemplateURL: `${apiBase}/site-setup-template`,
    siteSetupWorkbooksURL: `${apiBase}/site-setup-workbooks`,
    gatesURL: `${apiBase}/gates`,
    emailPreviewsURL: `${apiBase}/email-previews`,
    truckInspectionQuestionsURL: `${apiBase}/truck-inspection-questions`,
    partnerTruckInspectionTextsURL: `${apiBase}/partner-truck-inspection-texts`,
    truckInspectionSettingsURL: `${apiBase}/truck-inspection-settings`,
    truckInspectionsURL: `${apiBase}/truck-inspections`,
    reefersURL: `${apiBase}/reefers`,
    reeferChecksURL: `${apiBase}/reefer-checks`,
    reeferSettingsURL: `${apiBase}/reefer-settings`,
    reeferRoundsURL: `${apiBase}/reefer-rounds`,
    inventoryDashboardURL: `${apiBase}/inventory-dashboard`,
    yardDashboardURL: `${apiBase}/yard-dashboard`,
    bayInventoryCellsURL: `${apiBase}/bay-inventory-cells`,
    bayInventoryContainersURL: `${apiBase}/bay-inventory-containers`,
    driverArrivalsURL: `${apiBase}/driver-arrivals`,
    dockOperationsURL: `${apiBase}/dock-operations`,
    warehouseDashboardURL: `${apiBase}/warehouse-dashboard`,
    homeDashboardURL: `${apiBase}/home-dashboard`,
    dataExchangeConnectionsURL: `${apiBase}/data-exchange-connections`,
    dataExchangeConnectionChecksURL: `${apiBase}/data-exchange-connection-checks`,
    dataExchangeTransfersURL: `${apiBase}/data-exchange-transfers`,
    dataExchangeDocumentDefinitionsURL: `${apiBase}/data-exchange-document-definitions`,
    collectedFilesURL: `${apiBase}/collected-files`,
    partnerNoticeFieldsURL: `${apiBase}/partner-notice-fields`,
    dataExchangeDocumentDestinationsURL: `${apiBase}/data-exchange-document-destinations`,
    partnerCodeMapsURL: `${apiBase}/partner-code-maps`,
    unmatchedPartnerLocationCodesURL: `${apiBase}/unmatched-partner-location-codes`,
    dataExchangeDocumentURL: `${apiBase}/data-exchange-documents`,
    chassisURL: `${apiBase}/chassis`,
    gensetURL: `${apiBase}/gensets`,
    gangURL: `${apiBase}/gang`,
    partnerURL: `${apiBase}/Partner`,
    partnerProductURL: `${apiBase}/PartnerProduct`,
    warehouseURL: `${apiBase}/Warehouse`,
    shipURL: `${apiBase}/Ship`,
    yardURL: `${apiBase}/Yard`,
    bayURL: `${apiBase}/Bay`,
    cellURL: `${apiBase}/Cell`,
    locationProximityURL: `${apiBase}/LocationProximity`,
    yardPickURL: `${apiBase}/yard-picks`,
    yardPickSettingsURL: `${apiBase}/yard-pick-settings`,
    containerURL: `${apiBase}/Container`,
    inventorySupplyURL: `${apiBase}/InventorySupply`,
    forecastURL: `${apiBase}/Forecast`,
    forecastAlgorithmURL: `${apiBase}/ForecastAlgorithm`,
    logURL: `${apiBase}/Log`,
    jobScheduleURL: `${apiBase}/JobSchedule`,
    jobSettingsURL: `${apiBase}/job-settings`,
    tagURL: `${apiBase}/tag`,
    orderSubtypesURL: `${apiBase}/order-subtypes`,
    orderSubtypeImportSetupsURL: `${apiBase}/order-subtype-import-setups`,
    palletImportSetupsURL: `${apiBase}/pallet-import-setups`,
    orderImportSetupsURL: `${apiBase}/order-import-setups`,
    shippingAgentsURL: `${apiBase}/shipping-agents`,
    paymentsURL: `${apiBase}/payments`,
    // Truck Services (Mark, 2026-10-19): under the payments integration, their own store's, with
    // the price list a record's small lookup list (stores/_CONVENTIONS.md).
    truckServicesURL: `${apiBase}/payments/truck-services`,
    truckServiceSettingsURL: `${apiBase}/payments/truck-service-settings`,
    truckServicePricesURL: `${apiBase}/payments/truck-service-prices`,
    cashDrawerURL: `${apiBase}/payments/cash-drawer`,
    cashDrawerClosesURL: `${apiBase}/payments/cash-drawer-closes`,
    cashDrawerStartingCashURL: `${apiBase}/payments/cash-drawer-starting-cash`,
    cashDrawerDaysURL: `${apiBase}/payments/cash-drawer-days`,
    // The Square Terminals at the counter (Mark, 2026-10-28), set up behind the Truck Services gear.
    cardTerminalsURL: `${apiBase}/payments/card-terminals`,
    textMessagesURL: `${apiBase}/text-messages`,
    userURL: `${apiBase}/users`,
    // A partner's own people's log-ins, made on the partner's page (task 1309).
    partnerUsersURL: `${apiBase}/partner-users`,
    healthURL: `${apiBase}/health`,
    monitoredServicesURL: `${apiBase}/monitored-services`,
    serviceEventsURL: `${apiBase}/service-events`,
    publicStatusURL: `${apiBase}/health/status`,
    // The pallet surface. The legacy api/Pallet addresses that remain are producer-only and
    // are not called from the web.
    palletsURL: `${apiBase}/pallets`,
    // Each partner's pallet snapshot and how fresh its holds are (Mark, 2026-10-22).
    palletFilesURL: `${apiBase}/pallet-files`,
    // Moves a forklift driver made of a pallet ID two partners hold, for a clerk to say whose (task 2221).
    palletMovesToConfirmURL: `${apiBase}/pallet-moves-to-confirm`,
    unmappedContainersURL: `${apiBase}/unmapped-containers`,
    arrivedContainersURL: `${apiBase}/arrived-containers`,
    crowdedCellsURL: `${apiBase}/crowded-cells`,
    palletWrongContainersURL: `${apiBase}/pallet-wrong-containers`,
    // Its own object, not a sub-path on pallets: `sync` is the only noun the route
    // grammar allows in the action position.
    palletDestinationsURL: `${apiBase}/pallet-destinations`,
    palletIncidentURL: `${apiBase}/PalletIncident`,
    palletIncidentReasonCodeURL: `${apiBase}/PalletIncidentReasonCode`,
    palletIncidentStatusURL: `${apiBase}/PalletIncidentStatus`,
    palletIncidentPredefinedPhotoURL: `${apiBase}/PalletIncidentPredefinedPhoto`,
    warehouseRoomURL: `${apiBase}/WarehouseRoom`,
    sensorURL: `${apiBase}/Sensor`,
    roomClimateURL: `${apiBase}/room-climate`,
    productStockURL: `${apiBase}/product-stock`,
    palletStockURL: `${apiBase}/pallet-stock`,
    containerStockURL: `${apiBase}/container-stock`,
    scannerSettingsURL: `${apiBase}/Report/scannersettings`,
    inventoryLocationURL: `${apiBase}/InventoryLocation`,
    securityURL: `${apiBase}/security`,
    serviceClientsURL: `${apiBase}/service-clients`,
    permissionsURL: `${apiBase}/permissions`,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
}
